export function TrophyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Trophy--Streamline-Core" clip-path="url(#clip0_11085_7995)">
        <g id="trophy--reward-rating-trophy-social-award-media">
          <path
            id="Vector"
            d="M8 10.6348V14.8491"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M4.3125 14.8496H11.6875"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_3"
            d="M4.31208 1.15234H1.15137V4.31306C1.15137 6.05867 2.56647 7.47377 4.31208 7.47377V1.15234Z"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_4"
            d="M11.6875 1.15234H14.8482V4.31306C14.8482 6.05867 13.4332 7.47377 11.6875 7.47377V1.15234Z"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_5"
            d="M4.3125 1.15234V6.94699C4.3125 8.98354 5.96345 10.6345 8 10.6345C10.0366 10.6345 11.6875 8.98354 11.6875 6.94699V1.15234H4.3125Z"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11085_7995">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TrophyIcon;
